module.exports = __webpack_public_path__ + "extra-arms.png?22750a83ae058d27f334159c75928511";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/extra-arms.png
// module id = 110
// module chunks = 0